import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import LogFileCellRenderer from 'components/common/logFileCellRenderer'
import { formatDate } from 'utils/helpers'

export const getColumns = () =>
  [
    {
      headerName: 'ID',
      field: '_id',
      minWidth: 220,
    },
    {
      headerName: 'Upload ID',
      field: 'uploadId',
      minWidth: 290,
    },
    {
      headerName: 'Sync Type',
      field: 'syncType',
      cellRenderer: (params: ICellRendererParams) => {
        return <span className="capitalize">{params.value}</span>
      },
      maxWidth: 170,
    },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <span className="capitalize">
            {params.value?.split('_')?.join(' ')}
          </span>
        )
      },
      maxWidth: 170,
    },
    { headerName: 'Store', field: 'storeId', maxWidth: 170 },
    {
      headerName: 'Log File',
      field: 'logFileUrl',
      cellRenderer: (params: ICellRendererParams) => (
        <LogFileCellRenderer params={params} />
      ),
    },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
  ] as ColDef[]
